export enum ReviewPaymentsKind {
    Commission,
    Maketing,
    Ambassador
}